import { Component, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { secretKey, pagesWithTabs } from 'src/environments/environment';
import {
  AuthenticationStore,
  UserInfo,
  versionResponse,
} from './stores/authentication.store';
import { FirebaseAuthenticationService } from './services/firebase-authentication.service';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { LoaderService } from './services/loader.service';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import CryptoJS from 'crypto-js';
import { SocailMobileVerifiedComponent } from './shared-components/socail-mobile-verified/socail-mobile-verified.component';
import { AdvertisementComponent } from './shared-components/advertisement/advertisement.component';
import {
  Advertisement,
  AdvertisementResponse,
  BannerStore,
} from './stores/banner.store';
import { LoginPagePage } from './login-page/login-page.page';
import { register } from 'swiper/element/bundle';
register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  closed$ = new Subject<any>();
  showTabsUrl: string = null; // <-- show tabs by default
  userInfo: UserInfo;
  androidVersionNumber: string = '';
  iosVersionNumber: string = '';
  forceIosUpdate: number = 0;
  forceAndroidUpdate: number = 0;
  advertisementData: Array<Advertisement> = [];
  constructor(
    private translate: TranslateService,
    private router: Router,
    private authenticationStore: AuthenticationStore,
    private firebaseAuthenticationService: FirebaseAuthenticationService,
    private loaderService: LoaderService,
    private zone: NgZone,
    private appVersion: AppVersion,
    public platform: Platform,
    private alertController: AlertController,
    private modalCtrl: ModalController,
    private bannerStore: BannerStore
  ) {
    this.initializeApp();
    this.translate.setDefaultLang(
      this.userInfo && this.userInfo.language ? this.userInfo.language : 'pg'
    );
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntil(this.closed$)
      )
      .subscribe((event) => {
        if (pagesWithTabs.indexOf(event['url']) > -1) {
          this.showTabsUrl = event['url'];
        } else {
          this.showTabsUrl = null;
        }
      });
  }

  async ngOnInit() {
    this.authenticationStore.isLogin.subscribe(async (data) => {
      setTimeout(() => {
        if (this.router.url.split('/')[1] !== 'product') {
          if (this.router.url.split('/')[1] !== 'shop') {
            this.showTabsUrl = '/dashboard';
          }
        }
      }, 100);
      if (data) {
        var res: AdvertisementResponse =
          await this.bannerStore.getAdvertisement();
        this.advertisementData = res.data;
        if (this.advertisementData?.length > 0) {
          this.checkAdvertisement();
        }
      }
    });
    // if (this.authenticationStore.token) {
    try {
      var response = await this.authenticationStore.tokenVerify();
      this.authenticationStore.userInfo = response.data;
      this.checkPhoneNumber(response.data);
      var res: AdvertisementResponse =
        await this.bannerStore.getAdvertisement();
      this.advertisementData = res.data;
      if (this.advertisementData?.length > 0) {
        this.checkAdvertisement();
      }
      this.translate.setDefaultLang(
        response.data && response.data.language ? response.data.language : 'pg'
      );
      // this.router.navigate(['/dashboard']);
    } catch (error) {
      this.authenticationStore.userInfo = null;
      localStorage.removeItem('authToken');
    }
    // } else {
    //   const navigationExtras: NavigationExtras = {
    //     state: {
    //       onLoad: true,
    //     },
    //   };
    //   this.router.navigate(['/login-page'], navigationExtras);
    // }
    setTimeout(() => {
      if (this.router.url.split('/')[1] !== 'product') {
        if (this.router.url.split('/')[1] !== 'shop') {
          this.showTabsUrl = '/dashboard';
        }
      }
      // if (!this.authenticationStore.token) {
      //   this.showTabsUrl = null;
      // }
      this.checkForAppUpdate();
    }, 200);
  }

  async getUserData() {
    try {
      var response = await this.authenticationStore.tokenVerify();
      this.authenticationStore.userInfo = response.data;
      this.checkPhoneNumber(response.data);
      var res: AdvertisementResponse =
        await this.bannerStore.getAdvertisement();
      this.advertisementData = res.data;
      if (this.advertisementData?.length > 0) {
        this.checkAdvertisement();
      }
      this.translate.setDefaultLang(
        response.data && response.data.language ? response.data.language : 'pg'
      );
      // this.router.navigate(['/dashboard']);
    } catch (error) {
      this.authenticationStore.userInfo = null;
      localStorage.removeItem('authToken');
    }
  }

  ngOnDestroy() {
    this.closed$.next(true); // <-- close subscription when component is destroyed
  }

  ionViewDidEnter() {
    this.checkForAppUpdate();
  }

  async checkAdvertisement() {
    const modal = await this.modalCtrl.create({
      component: AdvertisementComponent,
      cssClass: this.platform.is('desktop')
        ? 'Successful-Created desktop-modal'
        : 'Successful-Created',
      backdropDismiss: false,
      componentProps: {
        advertisementData: this.advertisementData,
      },
    });
    modal.present();
  }

  async checkPhoneNumber(value) {
    if (!value.phone) {
      const modal = await this.modalCtrl.create({
        component: SocailMobileVerifiedComponent,
        cssClass: 'Successful-Created',
        backdropDismiss: false,
        componentProps: {
          email: value.email,
          pageType: true,
          forceNumber: true,
        },
      });
      modal.present();
    }
  }

  async checkForAppUpdate() {
    try {
      var appVersionNumber = await this.appVersion.getVersionNumber();
      // Make an API call or use any other method to get the latest app version data
      var res: versionResponse = await this.authenticationStore.version();
      this.androidVersionNumber = res.data.android_version;
      this.iosVersionNumber = res.data.iphone_version;
      this.forceAndroidUpdate = res.data.android_force_update;
      this.forceIosUpdate = res.data.iphone_force_update;
      if (this.platform.is('android')) {
        if (appVersionNumber < this.androidVersionNumber) {
          const updateMessage = `${this.translate.instant(
            'PLACEHOLDER_TEXT.NEW_VERSION'
          )} (${this.androidVersionNumber}) ${this.translate.instant(
            'PLACEHOLDER_TEXT.VERSION_AVAILABLE'
          )}`;
          if (this.forceAndroidUpdate == 1) {
            this.appForceUpdate(updateMessage);
          } else {
            this.appUpdate(updateMessage);
          }
        }
      } else {
        if (appVersionNumber < this.iosVersionNumber) {
          const updateMessage = `${this.translate.instant(
            'PLACEHOLDER_TEXT.NEW_VERSION'
          )} (${this.iosVersionNumber}) ${this.translate.instant(
            'PLACEHOLDER_TEXT.VERSION_AVAILABLE'
          )}`;
          if (this.forceIosUpdate == 1) {
            this.appForceUpdate(updateMessage);
          } else {
            this.appUpdate(updateMessage);
          }
        }
      }
    } catch (error) {
      console.error('Error checking for app update:', error);
    }
  }

  async appLink() {
    if (this.platform.is('android')) {
      await Browser.open({
        url: 'https://play.google.com/store/apps/details?id=com.nteka.mindmoverz',
      });
    } else {
      await Browser.open({
        url: 'https://apps.apple.com/us/app/loja-nteka/id1667200848',
      });
    }
  }

  async appForceUpdate(updateMessage: string = '') {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: updateMessage,
      cssClass: 'publish-alert',
      backdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('PLACEHOLDER_TEXT.UPDATE'),
          cssClass: 'new-product',
          handler: async () => {
            this.appLink();
          },
        },
      ],
    });
    await alert.present();
  }

  async appUpdate(updateMessage: string = '') {
    const alert = await this.alertController.create({
      mode: 'ios',
      cssClass: 'publish-alert',
      header: updateMessage,
      buttons: [
        {
          text: this.translate.instant('OWN_SHOP.GO_BACK'),
          cssClass: 'button-gray',
          handler: () => {},
        },
        {
          text: this.translate.instant('OWN_SHOP.YES'),
          cssClass: 'new-product',
          handler: async () => {
            this.appLink();
          },
        },
      ],
    });
    await alert.present();
  }

  private async initializeApp(): Promise<void> {
    await this.configureAndroidStatusBar();
    await this.firebaseAuthenticationService.initialize();
    this.pushConfigure();
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(async () => {
        let slug: any = event.url.split('.com/app/').pop();
        slug = slug.replace(/Por21Ld/g, '/');
        const decryptedBytes = await CryptoJS.AES.decrypt(slug, secretKey);
        let decryptedLink = await decryptedBytes.toString(CryptoJS.enc.Utf8);
        decryptedLink = decodeURIComponent(decryptedLink);
        if (decryptedLink) {
          if (this.authenticationStore.token) {
            this.router.navigateByUrl(decryptedLink);
          } else {
            if (this.platform.is('mobile')) {
              const navigationExtras: NavigationExtras = {
                state: {
                  onLoad: true,
                  deepLink: decryptedLink,
                },
              };
              this.router.navigate(['/login-page'], navigationExtras);
            } else {
              // desktop login is a full page (was a modal)
              this.router.navigate(['/login-page'], {
                state: { returnUrl: this.router.url, onLoad: true, deepLink: decryptedLink },
              });
            }
          }
        }
      });
    });
  }

  async pushConfigure() {
    let permStatus = await PushNotifications.checkPermissions();
    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }
    PushNotifications.requestPermissions()
      .then((result) => {
        if (result.receive === 'granted') {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        } else {
          // Show some error
        }
      })
      .catch((reason) => {
        // alert(JSON.stringify(reason));
      });

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration', (token: Token) => {
      localStorage.setItem('device_token', token.value.toString());
      // alert('Push registration success, token: ' + JSON.stringify(token));
    });

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError', (error: any) => {
      // alert('Error on registration: ' + JSON.stringify(error));
    });

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener(
      'pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        this.loaderService.presentToast(
          notification.data.aps.alert.title,
          'top',
          'success'
        );
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        if (notification.notification.data.link) {
          const openCapacitorSite = async () => {
            await Browser.open({ url: notification.notification.data.link });
          };
        } else if (notification.notification.data.contentId) {
          // this.router.navigate(['/content-detail/'+notification.notification.data.contentId]);
        }
      }
    );
  }

  private async configureAndroidStatusBar(): Promise<void> {
    if (
      Capacitor.getPlatform() !== 'android' ||
      !Capacitor.isNativePlatform() ||
      !Capacitor.isPluginAvailable('StatusBar')
    ) {
      return;
    }

    try {
      const statusBarInfo = await StatusBar.getInfo();
      document.documentElement.classList.toggle(
        'nteka-android-statusbar-overlay',
        statusBarInfo.overlays === true
      );

      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#fbf8f5' });
      await StatusBar.setStyle({ style: Style.Light });
    } catch (error) {
      console.error('Error configuring Android status bar:', error);
    }
  }
}
